import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiStar, FiGift, FiTrendingUp, FiCheckCircle, FiExternalLink } from 'react-icons/fi';
import { trackAffiliateClick } from '../services/api';
import './CasinoCard.css';

const CasinoCard = ({ casino, onClick, showRatingsAndProcons }) => {
  const [isHovered, setIsHovered] = useState(false);

  const getBonusTypeLabel = (type) => {
    const labels = {
      welcome: 'Welcome Bonus',
      deposit: 'Deposit Bonus',
      freespins: 'Free Spins',
      cashback: 'Cashback',
      nodeposit: 'No Deposit'
    };
    return labels[type] || type;
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <FiStar
        key={i}
        className={i < rating ? 'star filled' : 'star'}
      />
    ));
  };

  const logoContent = casino.logo ? (
    <img src={casino.logo} alt={casino.name} />
  ) : (
    <div className="logo-placeholder">🎰</div>
  );

  return (
    <motion.div
      className="casino-card"
      whileHover={{ y: -8, scale: 1.02 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      {/* Placement Badge */}
      {casino.placement && casino.placement !== 999 && (
        <div className="placement-badge">
          {casino.placement}
        </div>
      )}

      {/* Top Badge */}
      {casino.featured && (
        <motion.div
          className="featured-badge"
          initial={{ rotate: -5 }}
          animate={{ rotate: isHovered ? 0 : -5 }}
        >
          <FiTrendingUp /> Top Offer
        </motion.div>
      )}

      {/* Casino Logo – links to the offer's own shareable page */}
      {casino.detailUrl ? (
        <a
          className="casino-logo casino-logo-link"
          href={casino.detailUrl}
          title={`${casino.name} – Angebotsseite öffnen`}
          onClick={(e) => e.stopPropagation()}
        >
          {logoContent}
        </a>
      ) : (
        <div className="casino-logo">{logoContent}</div>
      )}

      {/* Casino Name */}
      <h3 className="casino-name">{casino.name}</h3>

      {/* Casino Rating */}
      {showRatingsAndProcons && (
        <div className="casino-rating">
          <div className="stars">
            {renderStars(casino.rating)}
          </div>
          <span className="rating-text">{casino.rating}.0/5</span>
        </div>
      )}

      {/* Bonus Info - New Layout */}
      <div className="bonus-info">
        <div className="bonus-grid">
          <div className="bonus-stat">
            <div className="stat-value">{casino.bonusPercentage || 100}%</div>
            <div className="stat-label">{casino.bonusStickyType?.toUpperCase() || 'WAGERFREE'}</div>
          </div>
          <div className="bonus-stat">
            <div className="stat-value">{casino.maxBonus || 1000}€</div>
            <div className="stat-label">MAX BONUS</div>
          </div>
          <div className="bonus-stat">
            <div className="stat-value">{casino.wageringRequirement || 0}x</div>
            <div className="stat-label">WAGER ({casino.wagerType || 'D'})</div>
          </div>
          <div className="bonus-stat">
            <div className="stat-value">{casino.maxBet || 5}€</div>
            <div className="stat-label">MAXBET</div>
          </div>
        </div>
      </div>

      {/* Features */}
      {casino.features && casino.features.length > 0 && (
        <div className="features">
          {casino.features.slice(0, 3).map((feature, index) => (
            <div key={index} className="feature">
              <FiCheckCircle className="check-icon" />
              <span>{feature}</span>
            </div>
          ))}
        </div>
      )}

      {/* CTA Buttons */}
      <div className="card-buttons">
        <motion.a
          href={casino.affiliateLink || '#'}
          target="_blank"
          rel="noopener noreferrer"
          className="card-cta-primary"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={(e) => {
            e.stopPropagation();
            trackAffiliateClick(casino.id);
          }}
        >
          Claim Bonus Now
          <FiExternalLink />
        </motion.a>
        <motion.button
          className="card-cta-secondary"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          View Details
        </motion.button>
      </div>

      {/* Terms Link */}
      <div className="terms">
        <small>18+ | T&Cs apply</small>
      </div>
    </motion.div>
  );
};

export default CasinoCard;
